import { type ChangeEvent, type FormEvent, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import type { MultiLang } from '../../config';
import Functions from '../../functions';
import type BulletinContext from './BulletinContext';

interface Props {
    lang: MultiLang;
    context: BulletinContext;
    topicId: number;
    num: number;
}

const STORY_NUMS: ReadonlyArray<number> = [5, 10, 15, 20, 30];

const BulletinStoriesSelect = (props: Props) => {
    const { lang, context } = props;
    const location = useLocation();
    const navigate = useNavigate();
    const [topicId, setTopicId] = useState(props.topicId);
    const [num, setNum] = useState(props.num);

    // Moving to another page resets the selection to what that page shows.
    // biome-ignore lint/correctness/useExhaustiveDependencies: reset only when the address changes
    useEffect(() => {
        setTopicId(props.topicId);
        setNum(props.num);
    }, [location.pathname, location.search, location.hash]);

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        void navigate(context.getTopicUrl(topicId, num, 0));
    };

    const topics = context.getTopics();
    return (
        <div style={{ textAlign: 'center' }}>
            <form onSubmit={handleSubmit}>
                <select
                    value={topicId}
                    onChange={(event: ChangeEvent<HTMLSelectElement>) => setTopicId(parseInt(event.target.value, 10))}
                >
                    <option value="0">----</option>
                    {topics.map((topic) => (
                        <option key={topic.id} value={topic.id}>
                            {Functions.mlang(topic.title, lang)}
                        </option>
                    ))}
                </select>
                &nbsp;
                <select
                    value={num}
                    onChange={(event: ChangeEvent<HTMLSelectElement>) => setNum(parseInt(event.target.value, 10))}
                >
                    {STORY_NUMS.map((value) => (
                        <option key={value} value={value}>
                            {value}
                        </option>
                    ))}
                </select>
                &nbsp;
                <input type="submit" value={Functions.mlang('[en]Go![/en][ja]送信[/ja]', lang)} />
            </form>
        </div>
    );
};

export default BulletinStoriesSelect;
